/**
 * Entry point index.js for UMD packaging
 */
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';

// import OHIFVTKExtension from '@ohif/extension-vtk';
// import OHIFDicomMicroscopyExtension from '@ohif/extension-dicom-microscopy';

function installViewer(config, containerId = 'root', callback) {
  // const defaultExtensions = [OHIFVTKExtension, OHIFDicomMicroscopyExtension];
  const container = document.getElementById(containerId);

  if (!container) {
    throw new Error(
      "No root element found to install viewer. Please add a <div> with the id 'root', or pass a DOM element into the installViewer function."
    );
  }

  // return ReactDOM.render(<App config={config} defaultExtensions={defaultExtensions}/>, container, callback);
  return ReactDOM.render(<App config={config} />, container, callback);
}

export { App, installViewer };
